import type { SimpleChoiceType } from '@/features/ChoicesLists/Simple/types';

export enum CHOICE_TYPE {
  API = 'api',
  SIMPLE = 'simple',
}

export type ChoiceValueValidation = {
  [key in SimpleChoiceType]?: {
    path: string;
    value: unknown;
  };
};
